<template>
  <div class="my-4 w-full mr-16 xs:!mr-0 w-full">
    <div class="mt-2 pb-2">
      <div class="flex justify-end">
        <inertia-link
          :href="route('app.task.create', farmer.id)"
          class="inline-flex mb-3 justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-full text-white bg-[#1E660B] hover:bg-[#1E660B] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          New Task +
        </inertia-link>
      </div>

      <div v-if="tasks.length === 0" class="bg-white px-6 py-4 my-4">
        <strong>No Tasks.</strong>
      </div>

      <table
        v-if="tasks.length > 0"
        class="table-auto min-w-full divide-y divide-gray-400 border-b border-gray-400 border-collapse rounded-lg"
      >
        <thead>
          <tr class="bg-gray-200 font-bold text-sm text-gray-900">
            <th scope="col" class="px-1 py-2.5 text-left">ID</th>
            <th scope="col" class="px-1 py-2.5 text-left">Date</th>
            <th scope="col" class="px-1 py-2.5 text-left">Status</th>
            <th scope="col" class="px-1 py-2.5 text-left">Ordered by</th>
            <th scope="col" class="px-1 py-2.5 text-left">Schedule From</th>
            <th scope="col" class="px-1 py-2.5 text-left">Schedule To</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(task, index) in tasks"
            :key="index"
            class="odd:bg-white even:bg-slate-100 text-gray-900 text-sm"
          >
            <td class="px-1 py-2.5">
              {{ task.task_id }}
            </td>
            <td class="px-1 py-2.5">
              {{ task.date }}
            </td>
            <td class="px-1 py-2.5">
              {{ task.status }}
            </td>
            <td class="px-1 py-2.5">
              {{ task.user }}
            </td>
            <td class="px-1 py-2.5">
              {{ task.active_date }}
            </td>
            <td class="px-1 py-2.5">
              {{ task.complete_date }}
            </td>
            <td class="w-10 px-1 py-2.5">
              <index-menu-item :links="taskLinks(task)" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import IndexMenuItem from "@/Components/IndexMenuItem";

export default {
  components: {
    IndexMenuItem,
  },
  props: {
    tasks: Array,
    farmer: Object,
  },
  methods: {
    taskLinks(task) {
      return {
        "Edit Task": route("app.task.edit", task.id),
        "View Task": route("app.task.view", { task: task.id, tab: "records" }),
      };
    },
  },
};
</script>
